<script setup lang="ts">
import SvgIcon from "@/components/svg.vue";
import { useRouter } from "vue-router";
import useUserStore from "@/stores/user";
import { watch } from "vue";
import LoginDialog from '@/components/user/loginDialog.vue'
import PaymentSwitchDialog from '@/components/payment-switch-dialog.vue'

const router = useRouter();
const userStore = useUserStore();
const goQuestion = () => {
  // 埋点开始
  window.collectEvent("zmgai_index_help_click", {
    is_login: userStore.token,
    user_id: userStore.userinfo?.userId,
    user_name: userStore.userinfo?.nickName,
  });
  // 埋点结束
  router.push({ path: "/question" });
};
let chatbotToken = ref<any>("");
// window.AlimeDialog({
//   from: "0Xb7lneG3Z",
//   params: {
//     _user_access_token: chatbotToken.value,
//   },
// });

watch(
  () => userStore.chatbotToken,
  (newVal) => {
    if (newVal) {
      // console.log("userStore.chatbotToken",newVal);
      chatbotToken.value = newVal;
      window.AlimeDialog({
        from: "0Xb7lneG3Z",
        params: {
          _user_access_token: chatbotToken.value,
        },
      });
    } else {
      // console.log("无chatbotToken");
      chatbotToken.value = "";
    }
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <!-- <div
    @click.stop="goQuestion"
    class="question_box cursor-pointer text-22px fixed right-20px bottom-100px flex items-center justify-center"
  >
    <div
      class="question-icon w-30px h-30px pt-3px lh-30px text-center text-20px"
    >
      <svg-icon name="question" color="#fff"></svg-icon>
    </div>
    <div class="qustion-test text-15px text-#fff flex-shrink-0">常见问题</div>
  </div> -->
  <router-view></router-view>
  <LoginDialog v-if="userStore.dialogLogin"  class="login-component"></LoginDialog>
  <PaymentSwitchDialog />
</template>

<style lang="scss" scoped>
.question_box {
  // transition: 'width' .2s linear;
  // transform: translateX(65px);
  // background:rgb(133,171,249);
  color: #fff;
  cursor: pointer;
  // padding:0 5px;
  // padding-right:12px;
  border-radius: 20px;
  background: rgb(133, 171, 249);
  z-index: 1000;

  .qustion-test {
    width: 0;
    height: 0;
    overflow: hidden;
    white-space: nowrap;
    // transition: all .2s linear;
    transition-property: width;
    transition-duration: 0.2s;
    transition-timing-function: linear;
  }

  .question-icon {
  }
}

.question_box:hover {
  background: rgb(133, 171, 249);
  // transform: translateX(0);
  border-radius: 6px;
  z-index: 1000;
  .question-icon {
    padding-left: 8px;
    margin-right: 12px;
  }
  .qustion-test {
    width: 92px;
    height: auto;
  }
}
:deep(#J_xiaomi_dialog .J_weaklogo) {
  position: relative !important;
  bottom: 90px !important;
  right: -20px !important;
  width: 30px !important;
  height: auto !important;
}
:deep(#J_xiaomi_dialog .J_Dialog .alicare-dialog-wrapper .alicare-fake-header){z-index: 1;}
#J_xiaomi_dialog .J_Dialog .alicare-dialog-wrapper .alicare-fake-header{z-index: 1;}
#J_xiaomi_dialog .J_weaklogo {
  position: relative !important;
  bottom: 90px !important;
  right: -20px !important;
  width: 30px !important;
  height: auto !important;
}
</style>
<style>
:deep(#J_xiaomi_dialog .J_weaklogo) {
  position: relative !important;
  bottom: 90px !important;
  right: -20px !important;
  width: 30px !important;
  height: auto !important;
}
#J_xiaomi_dialog .J_weaklogo {
  position: relative !important;
  bottom: 90px !important;
  right: -20px !important;
  width: 30px !important;
  height: auto !important;
}
</style>
